import React, { useState, useEffect } from "react";
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, NavLink, useLocation } from "react-router-dom";
import YourLogo from "../../Assets/Images/Pro_Logo.png";
import "../../Assets/Style/style.css"
import "./sidebar.css"
import { RxHamburgerMenu } from "react-icons/rx";
import { FiSearch, FiX } from "react-icons/fi";
import { AiOutlineStock, AiOutlineBulb } from "react-icons/ai";
import { useSelector } from "react-redux";
import { getCompany } from "../../../Redux/selecters";
import { IoReceiptOutline } from "react-icons/io5";
import { RiReservedLine, RiRefund2Line, RiStickyNoteLine, RiIndeterminateCircleFill } from "react-icons/ri";
import { TbLockAccess } from "react-icons/tb";
import { FcApproval } from "react-icons/fc";
import { TbStatusChange } from "react-icons/tb";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { FaRegFile } from "react-icons/fa6";
import {
  MdOutlineAssignment,
  MdSupportAgent, MdOutlineAnalytics,
  MdOutlineManageAccounts, MdAutorenew,
  MdOutlineAttachMoney,
  MdOutlineSwapHoriz,
  MdOutlineAccountBalanceWallet,
  MdOutlineEventBusy,
  MdOutlineCake,
} from "react-icons/md";
import {
  BsGraphDownArrow,
  BsFileEarmarkBarGraph,
  BsGraphUpArrow,
  BsPersonVcard,
  BsPersonLinesFill,
  BsPrinter
} from "react-icons/bs";
const PMSideBar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    lease: false,
    reports: false,
    master: false,
  });
  const [lastOpenMenu, setLastOpenMenu] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const companies = useSelector(getCompany);
  const pathname = location.pathname;
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);
  const isSearching = searchTerm.trim().length > 0;

  const isVisible = (formName) => {
    const hasPermission = permissions?.some(
      (permission) => permission.formName === formName && permission.canView
    );
    if (!hasPermission) return false;
    if (!isSearching) return true;
    return formName.toLowerCase().includes(searchTerm.trim().toLowerCase());
  };

  const leaseFormNames = [
    "Lease Reservation",
    "Lease Reservation Approval",
    "Lease Agreement",
    "Lease Invoice Print",
    "Lease Receipt",
    "Miscellaneous Receipt",
    "Sale Voucher",
    "Lease General Invoice Receipt",
    "Lease Reverse Receipt",
    "Lease Renewal",
    "Lease Agent Commission",
    "Termination",
    "Lease Termination Status",
    "Lease Termination Posting",
    "Lease Balance Amount Refund",
  ];
  const leaseReportFormNames = [
    "Agent Details Report",
    "Agent Direct Report",
    "HK Occupancy Report",
    "Lease Aging Analysis",
    "Lease Expiry Report",
    "Customer Birthday List",
    "Lease Agent Commission",
    "Lease Outstanding Report",
    "Lease Statement",
    "Move In Out Report",
    "Marketing Move In Out Report",
    "Occupancy Report",
    "Receipt Log Narration",
    "Receipt Log Receipt No",
    "Lease Reprint",
    "Refund Analysis",
    "Revenue Rental Report",
    "Unit Revenue Loss",
    "Unit Analysis Status",
    "PM Unit Listing",
  ];
  const hasLeaseMatch = leaseFormNames.some((name) => isVisible(name));
  const hasLeaseReportMatch = leaseReportFormNames.some((name) => isVisible(name));

  const hasLeaseReportAccess = permissions?.some(
    permission =>
      permission.canView &&
      [
        "Occupancy Report",
        "HK Occupancy Report",
        "Lease Statement",
        "Receipt Log Receipt No",
        "Receipt Log Narration",
        "Revenue Rental Report",
        "Move In Out Report",
        "Marketing Move In Out Report",
        "Lease Expiry Report",
        "Customer Birthday List",
        "Lease Agent Commission",
        "Refund Analysis",
        "Lease Aging Analysis",
        "Unit Revenue Loss",
        "Lease Reprint",
        "Unit Analysis Status",
        "PM Unit Listing",
      ].includes(permission.formName)
  );

  useEffect(() => {
    setOpenMenus({
      lease: location.pathname.startsWith('/Lease/Management/Lease'),
      reports: location.pathname.startsWith('/Lease/Management/Report'),
      master: location.pathname.startsWith('/Lease/Management/Master'),
    });
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.startsWith('/Lease/Management/Lease')) {
      setLastOpenMenu('lease');
    }
    if (location.pathname.startsWith('/Lease/Management/Report')) {
      setLastOpenMenu('reports');
    }
    if (location.pathname.startsWith('/Lease/Management/Master')) {
      setLastOpenMenu('master');
    }
  }, [location.pathname]);
  useEffect(() => {
    if (location.pathname === '/' && lastOpenMenu) {
      setOpenMenus((prev) => ({
        ...prev,
        [lastOpenMenu]: true,
      }));
    }
  }, [location.pathname, lastOpenMenu]);

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  return (

    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          // <a href="/Inventory" className="navbar-brand start">
          //   <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '40px', paddingTop: '8px', paddingBottom: '8px' }} />
          // </a>
          ""
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '75px' }} />
            {/* <span className="logoName" style={{ marginLeft: '8px' }}>
              {companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.charAt(0).toUpperCase() +
                companies?.selectedCompany?.logo?.split('/').pop()?.split('.').slice(0, -1).join('.')?.slice(1).toLowerCase()}
            </span> */}
          </a>
        )}
        {!collapsed && (
          <div className="sidebar-search">
            <FiSearch size={16} className="sidebar-search-icon" />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {isSearching && (
              <FiX
                size={16}
                className="sidebar-search-clear"
                onClick={() => setSearchTerm("")}
              />
            )}
          </div>
        )}
        <Menu className="mt-2">
          {isVisible("Dashboard") && (
            <MenuItem
              icon={<AiOutlineStock size={23} />}
              active={location.pathname === '/'}
            >
              <NavLink to="/">
                <div>DashBoard</div>
              </NavLink>
            </MenuItem>
          )}
          {isVisible("User Property Access") && (
            <MenuItem
              icon={<TbLockAccess size={23} />}
              active={pathname.startsWith('/Lease/Management/Property/Access')}
            >
              <NavLink to="/Lease/Management/Property/Access">
                <div className={`submenu ${location.pathname === "/Lease/Management/Property/Access" ? 'subactive' : ''}`}>User Property Access</div>
              </NavLink>
            </MenuItem>
          )}
          {(!isSearching || hasLeaseMatch) && (
          <SubMenu
            icon={<MdOutlineAssignment size={22} />}
            title="Lease"
            open={isSearching ? hasLeaseMatch : openMenus.lease}
            onOpenChange={(open) =>
              setOpenMenus((prev) => ({ ...prev, lease: open }))
            }

          >
            {isVisible("Lease Reservation") && (
              <MenuItem
                icon={<RiReservedLine size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Reservation')}
              >
                <NavLink to="/Lease/Management/Lease/Reservation">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Reservation/" ? 'subactive' : ''}`}>Lease Reservation</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Reservation Approval") && (
              <MenuItem
                icon={<FcApproval size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Approval')}
              >
                <NavLink to="/Lease/Management/Lease/Approval">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Approval" ? 'subactive' : ''}`}>Reservation Approval</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Agreement") && (
              <MenuItem
                icon={<RiReservedLine size={23} />}
                active={pathname.startsWith('/Lease/Management/LeaseAgreement/')}
              >
                <NavLink to="/Lease/Management/LeaseAgreement/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/LeaseAgreement/" ? 'subactive' : ''}`}>Lease Agreement</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Invoice Print") && (
              <MenuItem icon={<MdOutlineAccountBalanceWallet size={18} />}
                active={pathname.startsWith('/Lease/Management/Lease/InvoicePrint')}
              >
                <NavLink to="/Lease/Management/Lease/InvoicePrint">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/InvoicePrint" ? 'subactive' : ''}`}> Lease Invoice Print</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease General Invoice") && (
              <MenuItem icon={<MdOutlineAccountBalanceWallet size={18} />}
                active={pathname.startsWith('/Lease/Management/Lease/GeneralInvoice/')}
              >
                <NavLink to="/Lease/Management/Lease/GeneralInvoice/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/GeneralInvoice/Listing" ? 'subactive' : ''}`}>General Invoice</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease General Invoice Receipt") && (
              <MenuItem
                icon={<IoReceiptOutline size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/GeneralInvoiceReceipt')}
              >
                <NavLink to="/Lease/Management/Lease/GeneralInvoiceReceipt/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/GeneralInvoiceReceipt/Listing" ? 'subactive' : ''}`}>Billwise Receipt</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Reverse Receipt") && (
              <MenuItem
                icon={<IoReceiptOutline size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/ReceiptReverse')}
              >
                <NavLink to="/Lease/Management/Lease/ReceiptReverse">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/ReceiptReverse" ? 'subactive' : ''}`}>Lease Receipt Reverse</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Receipt") && (
              <MenuItem
                icon={<IoReceiptOutline size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Receipt/')}
              >
                <NavLink to="/Lease/Management/Lease/Receipt/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Receipt/" ? 'subactive' : ''}`}>Lease Receipt</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Miscellaneous Receipt") && (
              <MenuItem
                icon={<IoReceiptOutline size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/MiscellaneousReceipt')}
              >
                <NavLink to="/Lease/Management/Lease/MiscellaneousReceipt">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/MiscellaneousReceipt" ? 'subactive' : ''}`}>Miscellaneous Receipt</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Sale Voucher") && (
              <MenuItem
                icon={<MdOutlineAttachMoney size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/SaleVoucher')}
              >
                <NavLink to="/Lease/Management/Lease/SaleVoucher">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/SaleVoucher" ? 'subactive' : ''}`}>Sale Voucher</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Renewal") && (
              <MenuItem
                icon={<MdAutorenew size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Renewal/')}
              >
                <NavLink to="/Lease/Management/Lease/Renewal/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Renewal/" ? 'subactive' : ''}`}>Lease Renewal </div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Agent Commission") && (
              <MenuItem
                icon={<MdSupportAgent size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Agent/Commission')}
              >
                <NavLink to="/Lease/Management/Lease/Agent/Commission">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Agent/Commission" ? 'subactive' : ''}`}>Lease Agent Commission</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Termination") && (
              <MenuItem
                icon={<RiIndeterminateCircleFill size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Termination')}
              >
                <NavLink to="/Lease/Management/Lease/Termination/Listing">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Termination" ? 'subactive' : ''}`}>Lease Termination  Notice</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Termination Status") && (
              <MenuItem
                icon={<TbStatusChange size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Term/Status')}
              >
                <NavLink to="/Lease/Management/Lease/Term/Status">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Term/Status" ? 'subactive' : ''}`}>Lease Termination Status</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Termination Posting") && (
              <MenuItem
                icon={<TbStatusChange size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/Term/Posting')}
              >
                <NavLink to="/Lease/Management/Lease/Term/Posting">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/Term/Posting" ? 'subactive' : ''}`}>Lease Termination Posting</div>
                </NavLink>
              </MenuItem>
            )}
            {isVisible("Lease Balance Amount Refund") && (
              <MenuItem
                icon={<MdOutlineAccountBalanceWallet size={23} />}
                active={pathname.startsWith('/Lease/Management/Lease/BalancePayment')}
              >
                <NavLink to="/Lease/Management/Lease/BalancePayment">
                  <div className={`submenu ${location.pathname === "/Lease/Management/Lease/BalancePayment" ? 'subactive' : ''}`}> Lease Balance Amt Refund</div>
                </NavLink>
              </MenuItem>
            )}
          </SubMenu>
          )}
          {isVisible("Property Tour") && (
            <MenuItem
              icon={<MdOutlineManageAccounts size={23} />}
              active={pathname.startsWith('/Lease/Management/PropertyTour/')}
            >
              <NavLink to="/Lease/Management/PropertyTour/Listing">
                <div className={`submenu ${location.pathname === "/Lease/Management/PropertyTour/" ? 'subactive' : ''}`}>Property Tour</div>
              </NavLink>
            </MenuItem>
          )}
          {/*             <SubMenu
              icon={<IoReceiptOutline size={22} />}
              title="Master"
              open={openMenus.master}
              onOpenChange={(open) =>
                setOpenMenus((prev) => ({ ...prev, master: open }))
              }
            >
                <MenuItem
                  icon={<MdOutlineManageAccounts size={23} />}
                  active={pathname.startsWith('/Lease/Management/Master/Customer/')}
                >
                  <NavLink to="/Lease/Management/Master/Customer/Listing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Master/Customer/" ? 'subactive' : ''}`}>Tenant Management</div>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  icon={<MdOutlineManageAccounts size={23} />}
                  active={pathname.startsWith('/Lease/Management/Master/Agent/')}
                >
                  <NavLink to="/Lease/Management/Master/Agent/listing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Master/Agent" ? 'subactive' : ''}`}>Agent Master</div>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  icon={<MdOutlineManageAccounts size={23} />}
                  active={pathname.startsWith('/Lease/Management/Master/Broker/')}
                >
                  <NavLink to="/Lease/Management/Master/Broker/listing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Master/Broker" ? 'subactive' : ''}`}>Broker Master</div>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  icon={<MdOutlineManageAccounts size={23} />}
                  active={pathname.startsWith('/Lease/Management/Master/Property/')}
                >
                  <NavLink to="/Lease/Management/Master/Property/listing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Master/Property" ? 'subactive' : ''}`}>Property Master</div>
                  </NavLink>
                </MenuItem>
                <MenuItem
                  icon={<MdOutlineManageAccounts size={23} />}
                  active={pathname.startsWith('/Lease/Management/Master/Unit/')}
                >
                  <NavLink to="/Lease/Management/Master/Unit/listing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Master/Unit" ? 'subactive' : ''}`}>Unit Master</div>
                  </NavLink>
                </MenuItem>
            </SubMenu>
          )} */}
          {hasLeaseReportAccess && (!isSearching || hasLeaseReportMatch) && (
            <SubMenu
              icon={<IoReceiptOutline size={22} />}
              title="Lease Reports"
              open={isSearching ? hasLeaseReportMatch : openMenus.reports}
              onOpenChange={(open) =>
                setOpenMenus((prev) => ({ ...prev, reports: open }))
              }
            >
              {isVisible("Agent Details Report") && (
                <MenuItem icon={<BsPersonLinesFill size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/AgentDetails')}
                >
                  <NavLink to="/Lease/Management/Report/AgentDetails">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/AgentDetails" ? 'subactive' : ''}`}>Agent Details Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Agent Direct Report") && (
                <MenuItem icon={<BsPersonVcard size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/AgentDirect')}
                >
                  <NavLink to="/Lease/Management/Report/AgentDirect">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/AgentDirect" ? 'subactive' : ''}`}>Agent Direct Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("HK Occupancy Report") && (
                <MenuItem icon={<HiOutlineOfficeBuilding size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/HK_Occupancy')}
                >
                  <NavLink to="/Lease/Management/Report/HK_Occupancy">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/HK_Occupancy" ? 'subactive' : ''}`}>HK Occupancy Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Aging Analysis") && (

                <MenuItem icon={<RiRefund2Line size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/AgeingAnalysis')}
                >
                  <NavLink to="/Lease/Management/Report/AgeingAnalysis">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/AgeingAnalysis" ? 'subactive' : ''}`}>Lease Aging Analysis</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Expiry Report") && (

                <MenuItem icon={<MdOutlineEventBusy size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/LeaseExpiry')}
                >
                  <NavLink to="/Lease/Management/Report/LeaseExpiry">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/LeaseExpiry" ? 'subactive' : ''}`}>Lease Expiry</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Customer Birthday List") && (
                <MenuItem icon={<MdOutlineCake size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/CustomerBirthdayList')}
                >
                  <NavLink to="/Lease/Management/Report/CustomerBirthdayList">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/CustomerBirthdayList" ? 'subactive' : ''}`}>Customer Birthday List</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Agent Commission") && (
                <MenuItem icon={<BsFileEarmarkBarGraph size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/AgentCommissionSummary')}
                >
                  <NavLink to="/Lease/Management/Report/AgentCommissionSummary">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/AgentCommissionSummary" ? 'subactive' : ''}`}>Agent Commission Summary</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Outstanding Report") && (
                <MenuItem icon={<BsFileEarmarkBarGraph size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/Outstanding')}
                >
                  <NavLink to="/Lease/Management/Report/Outstanding">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Outstanding" ? 'subactive' : ''}`}>Lease Outstanding</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Statement") && (

                <MenuItem icon={<FaRegFile size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/Lease_Statement')}
                >
                  <NavLink to="/Lease/Management/Report/Lease_Statement">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Lease_Statement" ? 'subactive' : ''}`}>Lease Statement</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Move In Out Report") && (

                <MenuItem icon={<MdOutlineSwapHoriz size={18} />}
                  active={pathname.startsWith("/Lease/Management/Report/Move_IN_OUT")}
                >
                  <NavLink to="/Lease/Management/Report/Move_IN_OUT">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Move_IN_OUT" ? 'subactive' : ''}`}>Move In Out Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Marketing Move In Out Report") && (

                <MenuItem icon={<MdOutlineSwapHoriz size={18} />}
                  active={pathname.startsWith("/Lease/Management/Report/Marketing_Move_IN_OUT")}
                >
                  <NavLink to="/Lease/Management/Report/Marketing_Move_IN_OUT">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Marketing_Move_IN_OUT" ? 'subactive' : ''}`}>Marketing Move In Out</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Occupancy Report") && (
                <MenuItem icon={<HiOutlineOfficeBuilding size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/Occupancy')}
                >
                  <NavLink to="/Lease/Management/Report/Occupancy">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Occupancy" ? 'subactive' : ''}`}>Occupancy Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Unit Analysis Status") && (
                <MenuItem icon={<MdOutlineAnalytics size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/UnitAnalysisStatus')}
                >
                  <NavLink to="/Lease/Management/Report/UnitAnalysisStatus">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/UnitAnalysisStatus" ? 'subactive' : ''}`}>Unit Analysis Status</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("PM Unit Listing") && (
                <MenuItem icon={<HiOutlineOfficeBuilding size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/PMUnitListing')}
                >
                  <NavLink to="/Lease/Management/Report/PMUnitListing">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/PMUnitListing" ? 'subactive' : ''}`}>PM Unit Listing</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Receipt Log Narration") && (

                <MenuItem icon={<RiStickyNoteLine size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/Receipt-log_Narration')}
                >
                  <NavLink to="/Lease/Management/Report/Receipt-log_Narration">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Receipt-log_Narration" ? 'subactive' : ''}`}>Receipt Log Narration</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Receipt Log Receipt No") && (

                <MenuItem icon={<IoReceiptOutline size={18} />}
                  active={pathname === '/Lease/Management/Report/Receipt-log'}
                >
                  <NavLink to="/Lease/Management/Report/Receipt-log">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Receipt-log" ? 'subactive' : ''}`}>Receipt Log Receipt No</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Lease Reprint") && (
                <MenuItem icon={<BsPrinter size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/rePrint')}
                >
                  <NavLink to="/Lease/Management/Report/rePrint">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/rePrint" ? 'subactive' : ''}`}>RePrint</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Refund Analysis") && (

                <MenuItem icon={<RiRefund2Line size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/RefundAnalysis')}
                >
                  <NavLink to="/Lease/Management/Report/RefundAnalysis">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/RefundAnalysis" ? 'subactive' : ''}`}>Refund Analysis</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Revenue Rental Report") && (

                <MenuItem icon={<MdOutlineAttachMoney size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/Revenue_Rental')}
                >
                  <NavLink to="/Lease/Management/Report/Revenue_Rental">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/Revenue_Rental" ? 'subactive' : ''}`}>Revenue Rental Report</div>
                  </NavLink>
                </MenuItem>
              )}
              {isVisible("Unit Revenue Loss") && (
                <MenuItem icon={<BsGraphDownArrow size={18} />}
                  active={pathname.startsWith('/Lease/Management/Report/UnitRevenueLoss')}
                >
                  <NavLink to="/Lease/Management/Report/UnitRevenueLoss">
                    <div className={`submenu ${location.pathname === "/Lease/Management/Report/UnitRevenueLoss" ? 'subactive' : ''}`}>Unit Revenue Loss</div>
                  </NavLink>
                </MenuItem>
              )}
            </SubMenu>

          )}
        </Menu>
        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '100px' : '300px' }}>
          <RxHamburgerMenu size={25} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default PMSideBar;
